import { CONDITIONAL_LIQUIDITY_CLIENT, INFO_CLIENT } from "config/constants/endpoints"
import request, { gql } from "graphql-request"
import { PairRedemptionResponse } from "./types"

export interface RedemptionResults {
  userPairRedemptions: PairRedemptionResponse[]
}

export const fetchPairRedemptions = async (
  account: string,
) => {
  try {
    const query = gql`
    query userPairRedemptions($account: Bytes!) {
      userPairRedemptions(
        where: {
          user: $account
        }, 
        orderBy: timestamp, 
        orderDirection: desc
      ) {
        id
        user
        pair {
          id
        }
        timestamp
        amount0
        amount1
        liquidity
        token0AmountRule
        token1AmountRule
      }
    }
    `
    const data = await request<RedemptionResults>(CONDITIONAL_LIQUIDITY_CLIENT, query, {
      account,
    })
    return { data, error: false }
  } catch (error) {
    console.error('Failed to pair redemption data', error)
    return { error: true }
  }
}